import { memo, useCallback, useEffect, useRef, useState } from "react";
import classes from "./classes.module.scss";
import Typography from "components/elements/Typography";
import LazyImage from "components/elements/LazyImage";
import { container } from "tsyringe";
import { useProjectId } from "hooks/useProjectId";
import ChoiceResponseResource from "common/resources/Choice/ChoiceResponseResource";
import VoteResultResponseResource from "common/resources/Vote/VoteResultResponseResource";
import ResultOption from "./ResultIOption";
import { VoteWithResults } from "hooks/useVote";
import ChoiceService from "services/projects/ChoiceService";

const choiceService = container.resolve(ChoiceService);

type IProps = {
	choice: ChoiceResponseResource;
	voteWithResults: VoteWithResults;
	showResults: boolean;
};

function getResultPercentage(choiceId: string, results: ReadonlyArray<VoteResultResponseResource>) {
	return results.find((result) => result.choiceId === choiceId)?.percentage ?? 0;
}

const formatPercentage = (percentage: number) => {
	return `${percentage.toFixed(2)}%`;
};

function VoteOption(props: IProps) {
	const { projectId } = useProjectId();
	const [imageUrl, setImageUrl] = useState<string | null>(null);
	const inputRef = useRef<HTMLInputElement>(null);

	const onInputClick = useCallback(() => {
		inputRef.current?.click();
	}, []);

	useEffect(() => {
		if (!props.choice.image) return;
		choiceService
			.downloadImage(projectId, props.voteWithResults.question.id, props.choice.id)
			.then((blob) => {
				setImageUrl(URL.createObjectURL(blob));
			})
			.catch(console.error);
	}, [projectId, props]);

	const percentage = formatPercentage(getResultPercentage(props.choice.id, props.voteWithResults.results));

	if (props.showResults) {
		return <ResultOption percentage={percentage} imageUrl={imageUrl} choice={props.choice} />;
	}

	return (
		<div className={classes["root"]} onClick={onInputClick}>
			{imageUrl && <LazyImage src={imageUrl} alt={props.choice.value} className={classes["avatar"]} />}
			<input ref={inputRef} type="radio" name="vote" value={props.choice.id} className={classes["radio"]} />
			<label htmlFor="vote">
				<Typography type="p" weight="regular" className={classes["label"]}>
					{props.choice.value}
				</Typography>
			</label>
		</div>
	);
}

export default memo(VoteOption);
